module.exports = __webpack_public_path__ + "img/12.9cd18418.svg";